"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseMediaQuery = void 0;
const parseMediaQuery = query => {
  const minWidthMatch = query.match(/min-width:\s*(\d+)px/);
  const maxWidthMatch = query.match(/max-width:\s*(\d+)px/);
  if (minWidthMatch?.[1]) {
    return {
      type: 'min-width',
      value: Number.parseInt(minWidthMatch[1], 10)
    };
  }
  if (maxWidthMatch?.[1]) {
    return {
      type: 'max-width',
      value: Number.parseInt(maxWidthMatch[1], 10)
    };
  }
  return null;
};
exports.parseMediaQuery = parseMediaQuery;
